

export class CompanyLicenseDetailsAddInput implements ICompanyLicenseDetailsAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The license issue date with 10 character limit */
    licenseIssueDate!: string;
    /** The license activation date with 10 character limit */
    licenseActivationDate!: string;
    /** The license expiry date with 10 character limit */
    licenseExpiryDate!: string;
    /** The license extended date with 10 character limit */
    licenseExtendDate!: string;
    /** Max vehicle number of company */
    maxVehicles!: number;
    /** Expiry message in days */
    showExpiryMessage!: number;
    /** The remark with 500 character limit */
    remark!: string;

    constructor(data?: ICompanyLicenseDetailsAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
            this.licenseIssueDate = _data["licenseIssueDate"];
            this.licenseActivationDate = _data["licenseActivationDate"];
            this.licenseExpiryDate = _data["licenseExpiryDate"];
            this.licenseExtendDate = _data["licenseExtendDate"];
            this.maxVehicles = _data["maxVehicles"];
            this.showExpiryMessage = _data["showExpiryMessage"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CompanyLicenseDetailsAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyLicenseDetailsAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        data["licenseIssueDate"] = this.licenseIssueDate;
        data["licenseActivationDate"] = this.licenseActivationDate;
        data["licenseExpiryDate"] = this.licenseExpiryDate;
        data["licenseExtendDate"] = this.licenseExtendDate;
        data["maxVehicles"] = this.maxVehicles;
        data["showExpiryMessage"] = this.showExpiryMessage;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface ICompanyLicenseDetailsAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The license issue date with 10 character limit */
    licenseIssueDate: string;
    /** The license activation date with 10 character limit */
    licenseActivationDate: string;
    /** The license expiry date with 10 character limit */
    licenseExpiryDate: string;
    /** The license extended date with 10 character limit */
    licenseExtendDate: string;
    /** Max vehicle number of company */
    maxVehicles: number;
    /** Expiry message in days */
    showExpiryMessage: number;
    /** The remark with 500 character limit */
    remark: string;
}

